import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
import { NotificationInfo, UserInfo } from "../../../../context";
import {
  AuditOutlined,
  CalendarOutlined,
  PlusOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import MerchantAddTransactionFoodPanda from "./MerchantAddTransactionFoodPanda";
import FoodPandaTransaction from "./FoodPandaTransaction";

const MerchantFoodPandaReports = () => {
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const [selectedTab, setSelectedTab] = useState("list");

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      align: "center",

      render: (date) => (
        <p style={{ textAlign: "left" }}>
          {moment.utc(new Date(date)).format("MMMM DD, YYYY")}
        </p>
      ),
    },
    {
      title: "Transaction Number",
      dataIndex: "transaction_no",
      align: "center",
      sorter: (a, b) => a.transaction_no - b.transaction_no,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "left" }}>{text}</p>,
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: 40 }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantFoodPandaSaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/foodpanda-report/get/transaction", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantOrderSaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantFoodPandaSaveList();
  }, [getMerchantFoodPandaSaveList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.transaction_no.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var DATEFROM = moment(new Date(values.date_from)).format("YYYY-MM-DD");
    var DATETO = moment(new Date(values.date_to)).format("YYYY-MM-DD");

    var date_from = moment(`${DATEFROM}T00:00:00`).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    var date_to = moment(`${DATETO}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");

    var params = {
      date_from,
      date_to,
      user_id: userData.data.id,
      status: 1,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/foodpanda-report/get/transaction", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        console.log("DATA: ", data);
        setMerchantOrderSaveList({ data, ready: true });
        setOpenFilterByDate(false);
        setLoading(false);

        // setTimeout(() => {
        //   const res = _.chain(data)
        //     .groupBy((g) => g.transaction_id)
        //     .map((value, key) => ({
        //       transaction_id: key,
        //       data: value,
        //       customer_name: value[0].customer_name,
        //       created_at: value[0].created_at,
        //       table_no: value[0].table_no,
        //       service_category: value[0].service_category,
        //       cashiered_by:
        //         value[0].customerordercashiered !== null
        //           ? value[0].customerordercashiered.firstname
        //           : "",
        //       cost: getTotalCost(value),
        //       discount: getTotalDiscount(value),
        //       dine_in: getTotalDineIn(value),
        //       take_out: getTotalTakeOut(value),
        //       pick_up: getTotalPickup(value),
        //       delivery: getTotalDelivery(value),
        //       cash: getTotalCash(value),
        //       ecash: getTotalECash(value),
        //     }))
        //     .value();
        //   const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        //   setMerchantOrderSaveList({ data: res2, ready: true });
        //   setTotalGross(calculateTotal(res, "gross"));
        //   setTotalDiscount(calculateTotal(res, "discount"));
        //   setTotalDineIn(calculateTotal(res, "dinein"));
        //   setTotalTakeOut(calculateTotal(res, "takeout"));
        //   setTotalPickup(calculateTotal(res, "pickup"));
        //   setTotalDelivery(calculateTotal(res, "delivery"));
        //   setTotalCash(calculateTotal(res, "cash"));
        //   setTotalECash(calculateTotal(res, "ecash"));

        // }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const exportToExcel = () => {
    const selectedColumns = [
      "transaction_date",
      "transaction_no",
      "customer_name",
      "cost",
    ]; // Add columns you want to export
    const filteredData = searchable.map((row) => {
      const filteredRow = {};
      selectedColumns.forEach((column) => {
        filteredRow[column] = row[column];
      });
      return filteredRow;
    });

    // const worksheet = XLSX.utils.json_to_sheet(
    //   searchable.length > 0 ? searchable : []
    // );

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "digimenu_foodpanda_report.xlsx");
  };

  return (
    <>
      {selectedTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                id="search"
                placeholder="Search Transaction #"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("form")}
              style={{ marginRight: 5 }}
            >
              Add Transaction
            </Button>

            <Tooltip title="Excel Export">
              <Button
                icon={<ExportOutlined />}
                style={{ marginRight: 5 }}
                onClick={exportToExcel}
              >
                Export
              </Button>
            </Tooltip>
            {/* PENDINGGGGGGGGGGGGGGGGGGGGG ----------------- */}
            <Tooltip title="Filter by date">
              <Button
                icon={<CalendarOutlined />}
                style={{ marginRight: 5 }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.transaction_id}
            />
          </div>
        </>
      )}

      {selectedTab === "form" && (
        <MerchantAddTransactionFoodPanda
          close={() => setSelectedTab("list")}
          getMerchantFoodPandaSaveList={() => getMerchantFoodPandaSaveList()}
        />
      )}

      {openDrawer && (
        <FoodPandaTransaction
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="delivery-filter2"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default MerchantFoodPandaReports;
